import React, {PureComponent as Component} from 'react';
import BFileOpen from '../ui/template/Browser/BFileOpen';
import BWindow from '../ui/template/Browser/BWindow';
import { MCbrowser } from './Context/browserContext';
import Routing from './Routing';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import $ from 'jquery';
import 'select2/dist/js/select2.min';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'select2/dist/css/select2.min.css';

$.fn.select2.defaults.set('amdLanguageBase', 'select2/i18n/');

class MyBrowser extends Component{

    constructor(props) {
        super(props);
        this.b1=new BWindow();
		this.bf1=new BFileOpen();
        this.mbr = { 
			pageBWindow:this.b1,
            pageBFileOpen:this.bf1,
        };
    }
 
    render() {
        return (
            <MCbrowser.Provider value={this.mbr} >
            <Routing    />
            </MCbrowser.Provider>
        );
    }
 
}

export default MyBrowser;
